import "./setupResizeObserver";
import React from "react";
import ReactDOM from "react-dom/client";
import "@carbon/styles/css/styles.css";
import "@carbon/charts/styles.css";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
